import {
	defaultTqcSolutionAnalDto,
	TqcSolutionAnalDto,
} from "src/dtos/tqcSolutionAnal/tqcSolutionAnalDto";

export interface TQC2070_R01Dto extends TqcSolutionAnalDto {
}

export const defaultTQC2070_R01Dto: TQC2070_R01Dto = {
	...defaultTqcSolutionAnalDto,
};
